import { GET_EVENTS, CLEAR_EVENTS } from "../actiontypes";

/* EventsReducer => 
    GET_EVENTS - Gets Events On Search 
    CLEAR_EVENTS - Cleans Array 
*/
export default (state = [], action) => {
    switch (action.type) {
        case GET_EVENTS:
            return [...action.payload];
        case CLEAR_EVENTS:
            return [];
        default:
            return state;
    }
};
